import { Column } from '../objects/column';
import { Preferences } from '../../profile/objects/preferences';
import { ListPreferenceResult, setListPreference } from '../../utils/list/utils/setListPreference';
import { DEFAULT_COLUMN } from '../constant/column';

export const AUTOMATIC_PRODUCT_MODULE = 'AUTOMATIC_PRODUCT';

export const DEFAULT_AUTOMATIC_PRODUCT_COLUMNS: Column[] = DEFAULT_COLUMN;

export const setAutomaticProductPreference = (prefs: Preferences[], cols: Column[]): ListPreferenceResult =>
    setListPreference(prefs, cols, {
        module: AUTOMATIC_PRODUCT_MODULE,
        default_columns: DEFAULT_AUTOMATIC_PRODUCT_COLUMNS,
        default_order_by: 'name',
        default_order: 'asc',
    });
